import AppLayout from "../components/layout/AppLayout";
import ControlPlaneDashboard from "../components/controlPlane/ControlPlaneDashboard";

export default function DashboardPage() {
  return (
    <AppLayout>
      <ControlPlaneDashboard />
    </AppLayout>
  );
}
